import { api } from '@/services/api';
import { useFeatureFlags } from './useFeatureFlags';

export interface RecordEventParameters {
  name: string;
  url: string;
  title?: string;
  referrer?: string;
  data?: Record<string, unknown>;
}

interface UseRecordEventResult {
  recordEvent: (parameters: RecordEventParameters) => Promise<void>;
}

export function useRecordEvent(): UseRecordEventResult {
  const { isUsageAnalyticsEnabled } = useFeatureFlags();

  const recordEvent = async (parameters: RecordEventParameters): Promise<void> => {
    if (!isUsageAnalyticsEnabled) {
      return;
    }
    try {
      await api.recordUsageEvent(parameters);
    } catch {
      // Silently fail - usage tracking should not interrupt user experience
    }
  };

  return { recordEvent };
}
